import { Injectable } from '@angular/core';
import { SplicingConnectors221ProjectHelper } from '@project/helper/splicing-connectors-221-project.helper';
import { DefaultProjectHelper } from './default-project.helper';
import { GdsProjectHelper } from './gds-project.helper';
import { McsProjectHelper } from './mcs-project.helper';
import { RailProjectHelper } from './rail-project.helper';
import { ProjectHelper } from './project.helper';

@Injectable({providedIn: 'root'})
export class ProjectHelperInitializer {
    constructor(
      private defaultHelper: DefaultProjectHelper,
      private gdsHelper: GdsProjectHelper,
      private mcsHelper: McsProjectHelper,
      private railHelper: RailProjectHelper,
      private readonly projectHelper: ProjectHelper,
      private readonly splicingConnectors221ProjectHelper: SplicingConnectors221ProjectHelper,
    ) {}

    public initialize() {
        // The initialization order is important!
        // Default Helper should be last!
        this.projectHelper.initialize([this.gdsHelper, this.mcsHelper, this.splicingConnectors221ProjectHelper, this.railHelper], this.defaultHelper);
    }
}
